import { BodyCompositionScreen } from '~/health/components/body-composition-screen/BodyCompositionScreen';

export default BodyCompositionScreen;
